/**
 * @expFlag public-show-auth-when-downloading-new-modal
 * @ticket CLOUDWEB-20007
 * @file
 */
import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { ALLOW_ANONYM_DOWNLOAD_PUBLIC, ANONYM_USER, IS_PHONE_BROWSER, IS_WEBVIEW } from 'reactApp/appHelpers/configHelpers';

export const abPublicShowAuthWhenDownloadingNewModal = getFeature('public-show-auth-when-downloading-new-modal');

export const abPublicShowAuthWhenDownloadingNewModalSelector = () => {
    if (!ANONYM_USER || ALLOW_ANONYM_DOWNLOAD_PUBLIC || IS_WEBVIEW || !IS_PHONE_BROWSER) {
        return false;
    }

    if (abPublicShowAuthWhenDownloadingNewModal === 'a') {
        return 'variant1';
    }

    if (abPublicShowAuthWhenDownloadingNewModal === 'b') {
        return 'variant2';
    }

    return false;
};
